import { Component, Input, inject } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {
  DxoEditingComponent,
  DxiColumnComponent,
  DxoPagingComponent,
  DxoPagerComponent,
  DxoFilterRowComponent,
  DxoTextsComponent,
  DxiValidationRuleComponent,
  DxoExportComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ScadenzeArticoliService } from 'src/app/shared/services/scadenze-articoli.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-grid-scadenze-articoli',
  templateUrl: './grid-scadenze-articoli.component.html',
  styleUrls: ['./grid-scadenze-articoli.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoTextsComponent,
    DxiValidationRuleComponent,
    DxoExportComponent
  ],
  standalone: true,
})
export class GridScadenzeArticoliComponent {
  private scandenzeS = inject(ScadenzeArticoliService);
  private alertS = inject(AlertService);

  @Input() idArticolo: number = 0;
  dataSource: any;

  constructor() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.scandenzeS.listByArticolo(this.idArticolo))
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        values.idArticolo = this.idArticolo;

        //Data
        const data = new Date(values.data);
        const realDay = data.getDate();
        const realMonth = data.getMonth();
        const realYear = data.getFullYear();
        values.data = new Date(Date.UTC(realYear, realMonth, realDay));

        return firstValueFrom(this.scandenzeS.insert(values))
          .then(() => {
            this.alertS.sendClickEvent();
            return values;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (values) => {
        console.log(values);
        return firstValueFrom(this.scandenzeS.remove(values))
          .then(() => {
            this.alertS.sendClickEvent();
          })
          .catch(() => {
            throw 'Deletion failed';
          });
      },
      update: (key, values) => {
        //Data
        const data = new Date(values.data);
        const realDay = data.getDate();
        const realMonth = data.getMonth();
        const realYear = data.getFullYear();
        values.data = new Date(Date.UTC(realYear, realMonth, realDay));

        return firstValueFrom(this.scandenzeS.update(key, values))
          .then(() => {
            this.alertS.sendClickEvent();
            return values;
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
    });
  }

  onUpdating(e : any) {
    // e.cancel = new Promise((resolve, reject) => {
    //   resolve('');
    // });
    for (const k in e.oldData) {
      if (e.newData[k] == undefined) {
        e.newData[k] = e.oldData[k];
      }
    }
  }

  onExporting(e: any){
    GridExportExcel(e, 'Scadenze Articolo', 'Scadenza_Articolo.xlsx');
  }
}
